import ApiService from './_api.service'

const PlaceService = {
    read: async function(id) {
        return (
            await ApiService.get(
                process.env.VUE_APP_API_PLACES_URL + (id ? id + '/' : '')
            )
        ).data
    }
}

export default PlaceService
export { PlaceService }
